import classNames from 'clsx'
import { oneOf, string } from 'prop-types'

const ProductLink = ({ name, link, headingLevel, className }) => {
  const titleClass = classNames(
    `a-${headingLevel} u-no-margin o-ProductLink__text`,
    className
  )

  return (
    <a href={link} className="o-ProductLink">
      <h2 className={titleClass} data-qa-id="product-name">
        {name}
      </h2>
    </a>
  )
}

ProductLink.propTypes = {
  name: string.isRequired,
  link: string.isRequired,
  headingLevel: oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
  className: string,
}

ProductLink.defaultProps = {
  headingLevel: 'h5',
  className: null,
}

export default ProductLink
